import { useTranslation } from "react-i18next";

interface SplitPaymentSummaryProps {
  totalAmount: number;
  ledgerTotal: number;
}

const SplitPaymentSummary = ({
  totalAmount,
  ledgerTotal,
}: SplitPaymentSummaryProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 items-start w-full md:w-auto">
      <div className="flex justify-between gap-4 w-full md:w-100">
        <span className="text-[clamp(1.4rem,3vw,2.2rem)] font-semibold">
          {t("posOrders.totalAmount")}:
        </span>
        <span className="text-[clamp(1.4rem,3vw,2.2rem)] font-bold">
          {totalAmount.toFixed(2)}
        </span>
      </div>
      <div className="flex justify-between gap-4 w-full md:w-100">
        <span className="text-[clamp(1.4rem,3vw,2.2rem)] lg:text-4xl">
          {t("posOrders.splitAmount")}:{" "}
        </span>
        <span className="text-[clamp(1.4rem,3vw,2.2rem)] lg:text-4xl">
          {ledgerTotal.toFixed(2)}
        </span>
      </div>
    </div>
  );
};

export default SplitPaymentSummary;
